import React from 'react'
import { Box, Button } from '@mui/material'
import Image from 'next/image'

type Props = {
  label: string
  srcUrl: string
  alt: string
  width?: number
  height?: number
  variant?: 'text' | 'outlined' | 'contained'
  color?: 'inherit' | 'primary' | 'secondary'
  size?: 'small' | 'medium' | 'large'
  disabled?: boolean
}

export const ImageButton: React.FC<Props> = ({ label, srcUrl, alt, width, height, variant, color, size, disabled }) => {
  return (
    <Button variant={variant ? variant : 'contained'} color={color || 'primary'} size={size || 'medium'} disabled={disabled}>
      <Box display={'block'} mt={2}>
        <Image src={srcUrl} alt={alt} width={width || 210} height={height || 200} />
        <Box textTransform={'none'}>{label}</Box>
      </Box>
    </Button>
  )
}
